import { useUserPreferencesStore } from '@mdvip/shared/stores/userPreferencesStore';
import { useShallow } from 'zustand/shallow';

export function useFontSize() {
  return useUserPreferencesStore(
    useShallow((s) => ({
      fontSize: s.fontSize,
      increaseFontSize: s.increaseFontSize,
      decreaseFontSize: s.decreaseFontSize,
      resetFontSize: s.resetFontSize,
    })),
  );
}
